@if (state.vm$ | async; as data) {
  <ui-browse-filter
    [form]="filterForm"
    pageKey="seznam-sablon"
    collapsibleLabel="Rozšířené filtrování"
    [cy]="{
      form: Cy_Katalog.form,
      panel: Cy_Katalog.specifikaceTab,
      search: Cy_Katalog.search,
      clear: Cy_Katalog.clear,
    }"
    (submitted)="submitFilter()"
    (cleared)="clearFilter()">
    <p description class="text-(length:--font-size-body-l) mt-0 mb-8">
      Zadejte kritéria typu oprávnění k zastupování, které chcete vyhledat.
    </p>
    <reza-seznam-sablon-filter></reza-seznam-sablon-filter>
  </ui-browse-filter>

  <p-table
    uiBrowseTable
    scrollHeight=""
    (onLazyLoad)="state.onLazyLoad($event)"
    [value]="data.result.content || []"
    [rows]="data.filter.pageAndSortList?.count"
    [first]="data.filter.pageAndSortList?.start"
    [totalRecords]="data.result.total || 0"
    [attr.data-cy]="Cy_Katalog.table">
    <ng-template #header>
      <tr>
        <th>Identifikátor</th>
        <th>Název</th>
        <th>Verze</th>
        <th>Typ</th>
        <th>Platnost od</th>
        <th>Platnost do</th>
        <th>Gestor</th>
        <th>Schváleno</th>
        <th>Publikováno</th>
        <th>Dokumentace</th>
      </tr>
    </ng-template>
    <ng-template #body let-sablona>
      <tr>
        <td>
          <a [routerLink]="" (click)="downloadPdf(sablona.id)" target="_blank" class="underline">
            {{ sablona.interni_id }}
          </a>
        </td>
        <td>{{ sablona.nazev }}</td>
        <td>{{ sablona.verze }}</td>
        <td>
          <ui-status-indicator [statusLabels]="publicSablonyTypStatuses" [status]="sablona.typ"></ui-status-indicator>
        </td>
        <td>{{ sablona.platnostOd | date: 'dd.MM.yyyy' }}</td>
        <td>{{ sablona.platnostDo | date: 'dd.MM.yyyy' }}</td>
        <td>{{ sablona.kodOvm | kodNazev: sablona.nazevOvm }}</td>
        <td>{{ sablona.datumSchvaleni | date: 'dd.MM.yyyy' }}</td>
        <td>{{ sablona.datumPublikace | date: 'dd.MM.yyyy' }}</td>
        <td>
          <!-- @if(sablona.dokumentace) { Zatim neni zadny identifikator v dto zda existuje dokumentace -->
          <a
            [routerLink]=""
            (click)="downloadDokumentace(sablona.id)"
            target="_blank"
            class="underline"
            [attr.data-cy]="Cy_Katalog.dokumentaceButton">
            Soubor
          </a>
          <!-- } -->
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ui-buttons>
    <button class="m-1 mb-6" (click)="goBack()" pButton><span pButtonLabel>Zpět</span></button>
  </ui-buttons>
}
